<div class="row progress-container">
  <div class="planet-item">
    <span *ngIf="numClosedLectures">
      <img [src]="getFirstPlanetIcon()" />
    </span>
  </div>
  <div class="col progress-bar-info-col">
    <div class="info-row">
      <div class="progressbar-title-container">
        <div [hidden]="!isLevelReached" class="falling-stars">
          <div class="banner flex row justify-content-center w-90">
            <div class="banner-corner first"></div>
            <div class="banner-main col-10">
              <div
                class="progress-title md-lg"
                [translate]="'LECTURES.PROGRESS.LEVEL_REACHED'"
                [translateParams]="{
                  steps: numClosedLectures,
                  planet: 'PLANETS.' + currentPlanet?.stage | translate
                }"
              ></div>
              <div
                class="progress-title sm"
                [translate]="'LECTURES.PROGRESS.LEVEL_REACHED_SM'"
                [translateParams]="{
                  steps: numClosedLectures,
                  planet: 'PLANETS.' + currentPlanet?.stage | translate
                }"
              ></div>
            </div>
            <div class="banner-corner second"></div>
          </div>
          <ng-lottie class="falling-stars-anim" [options]="options"> </ng-lottie>
        </div>
        <div class="progress-title">
            {{ numClosedLectures === 0 ? ('LECTURES.PROGRESS.BEGIN' | translate: {
                next: ('PLANETS.' + nextPlanet?.stage) | translate
            }) : '' }}
            <span class="md-lg">
            {{ numClosedLectures && !isLevelReached ? ('LECTURES.PROGRESS.ARRIVED' | translate: {
                current: ('PLANETS.' + currentPlanet?.stage) | translate
            }) : '' }}
            </span>
            {{ numClosedLectures && !isLevelReached && !isLast ? ('LECTURES.PROGRESS.TOGO' | translate: {
                next: ('PLANETS.' + nextPlanet?.stage) | translate,
                remaining: lectsToGo
            }) : '' }}
            {{ numClosedLectures && isLast ? ('LECTURES.PROGRESS.LAST' | translate: {
                next: ('PLANETS.' + nextPlanet?.stage) | translate,
                remaining: lectsToGo
            }) : '' }}
        </div>
      </div>
    </div>
    <div class="custom-progress-bar-container" #progressElementContainer>
      <mat-progress-bar #progressElement class="custom-progress-bar" mode="determinate" [value]="value" [attr.dir]="dir"> </mat-progress-bar>
      <div class="rocket" [attr.dir]="dir" [ngStyle]="{ 'inset-inline-start': 'calc(' + value + '% - 10px)' }">
        <img src="assets/images/progress/progress-rocket.gif" />
      </div>
    </div>
    <div class="info-row info-btns d-flex justify-content-end my-3">
      <div class="">
        <button class="info-btn px-1" (click)="onLeaderBoardClick()">
          <!-- <i class="link-icon feather icon-award"></i> -->
          <img src="assets/images/progress/trophy.svg" alt="progress bar info" />
        </button>
        <button class="info-btn px-1" (click)="onProgressInfoClick()">
          <img src="assets/images/progress/info.svg" alt="progress bar info" />
        </button>
      </div>
    </div>
  </div>
  <div class="planet-item">
    <img [src]="getSecondPlanetIcon()" />
  </div>
</div>
